import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import paths from 'commons/paths';
import { useMyPage } from 'hooks';
import { MyDepartmentBoardTable } from '../../pages/MyPage/Community/DepartmentBoard';
import { MySocietyBoardTable } from '../../pages/MyPage/Community/SocietyBoard';

const BOARD_COUNT_TO_SHOW = 5;

const SocietyBoardSection = () => {
  const { societyBoards, societyBoardsIsValidating, setPage } = useMyPage({});

  useEffect(() => {
    setPage('1');
  }, []);

  if (societyBoardsIsValidating) return <></>;

  return (
    <div className="mypage_section">
      <div className="mypage_inner">
        <div className="mypage_top">
          <h3 className="mypage_top_title">작성한 게시글 - 회사 밖 소모임</h3>
          {(societyBoards?.totalAmount as number) > BOARD_COUNT_TO_SHOW ? (
            <Link to={`${paths.getPath('mySocietyBoard')}`} className="mypage_top_link">
              모두 보기
            </Link>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="mypage_board list_table">
        <MySocietyBoardTable
          list={societyBoards?.societyBoardList || []}
          count={societyBoards?.totalAmount as number}
          limit={BOARD_COUNT_TO_SHOW}
          ga_belong="마이페이지/작성한 게시글 - 회사 밖 소모임"
        />
      </div>
    </div>
  );
};

export default SocietyBoardSection;
